<template>
  <el-dropdown trigger="click" class="mb-5" style="margin-top: 4px">
    <span :class="isMobile ? 'clear-dropdown' : ''">{{ languages[language].label }}</span>
    <el-dropdown-menu class="switcher-dropdown-menu" slot="dropdown">
      <el-dropdown-item
          v-for="l in languages"
          :key="l.lang"
          @click-="switchLanguage(l.lang)"
      >
        <a href="javascript:void(0);" :class="{ active: l.lang === language }"
           @click="switchLanguage(l.lang)">{{ l.label }}</a>
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
  import { mapState, mapGetters } from 'vuex';

  export default {
    name: 'LanguageSwitcher',
    computed: {
      ...mapState({
        language: state => state.app.language,
        languages: state => state.app.languages,
      }),
      ...mapGetters([
        'isMobile',
      ]),
    },
    methods: {
      switchLanguage(lang) {
        // console.log(lang);
        this.$store.dispatch('setLanguage', lang).then(() => {
          this.$router.go(0);
        });
      },
    },
  };
</script>
